const AllPaddlesPage = {
    selectors: {
      "categoryProducts": { selector: ".category-products", type: "all", scope: "document" },
      "navBtns": { selector: ".nav-btn", type: "all", scope: "document" },
      "categoryContainers": { selector: ".category-container", type: "all", scope: "document" },
      "readMoreBtn": { selector: ".read-more-btn", type: "single", scope: "document" },
      "readLessBtn": { selector: ".read-less-btn", type: "single", scope: "document" },
      "pageDesc": { selector: ".all-paddles-header p", type: "single", scope: "document" },
      "allPaddlesCategory": {selector: "#all-pickleball-paddles", type: "single", scope: "document"},
      "sortSelects": { selector: ".sort-by", type: "all", scope: "document" },
      "toolbars": { selector: ".toolbar", type: "all", scope: "document" },
      "numberInputs": { selector: "input[type='number']", type: "all", scope: "document" },
      "allProductCards": { selector: ".product-card", type: "all", scope: "document" },
      "navArrows": { selector: ".left-arrow, .right-arrow", type: "all", scope: "document" },
      "checkboxesCategory": { selector: ".filter-checkbox", type: "all", scope: "document" },
      "categoryFilters": { selector: ".category-filters", type: "single", scope: "document" },
      "h1El": { selector: "h1", type: "single", scope: "document" },
      "faqsContainers": { selector: ".category-faqs", type: "all", scope: "document" },
      "allPaddlesContainer": { selector: ".all-paddles-container", type: "single", scope: "document" },
      "seeAllBtns": { selector: "span.see-all-btn", type: "all", scope: "document" }
      },
    
    init: function() {
      Utility.fetchEls(this.selectors, this);
      this.category = 'all';
      this.handle = null;
      const { categoryProducts, pageDesc, readMoreBtn } = this;

      if (pageDesc.scrollHeight && pageDesc.scrollHeight > pageDesc.clientHeight) {
        readMoreBtn.style.display = 'block';
      }
      this.initEventListeners();
    },
    initEventListeners: function() {
      const { seeAllBtns, 
             navBtns, 
             readMoreBtn, 
             readLessBtn, 
             pageDesc, 
             sortSelects, 
             filtersBtns, 
             numberInputs, 
             navArrows, 
             categoryProducts,
             checkboxesCategory,
             categoryFilters,
             allPaddlesContainer
            } = this;

      if (allPaddlesContainer) {
        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.get('sort_by');
        if (!sortBy) {
          this.setMaxHeight(allPaddlesContainer);
        }
      }

      if (window.location.href.includes('https://www.selkirk.com/collections/pickleball-paddles') && !window.location.href.includes('?sort_by')) {
        if (window.innerWidth < 769) {
          categoryProducts.forEach((category) => {
            this.setMaxHeight(category);
          });
        }
      }

      navArrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const container = document.querySelector('.nav-btns');
          const width = container.offsetWidth;
          if (arrow.dataset.direction === 'right') {
            Utility.smoothScroll(container, width / 2, 500);
        } else {
            Utility.smoothScroll(container, -(width / 2), 500);
        }
        });
      })

      readMoreBtn.addEventListener('click', () => {
          readMoreBtn.style.display = 'none';
          readLessBtn.style.display = 'block';
          pageDesc.style.display = 'block';
          pageDesc.style.overflow = 'visible';
          pageDesc.style.height = 'auto';
          pageDesc.style.webkitBoxOrient = 'horizontal';
      });
      
      readLessBtn.addEventListener('click', () => {
          readMoreBtn.style.display = 'block';
          readLessBtn.style.display = 'none';
          pageDesc.style.display = '-webkit-box';
          pageDesc.style.webkitBoxOrient = 'vertical';
          pageDesc.style.webkitLineClamp = "2";
          pageDesc.style.overflow = 'hidden';
      });

      window.addEventListener('resize', () => {
        if (pageDesc.scrollHeight > pageDesc.clientHeight) {
          readMoreBtn.style.display = 'block';
        } else {
          readMoreBtn.style.display = 'none';
        }
      });

      sortSelects.forEach((select) => {
        select.addEventListener('change', () => {
          this.sortProducts(select.value)
        });
      });

      this.checkboxesCategory.forEach(checkbox => {
        checkbox.addEventListener('change', (event) => {
          this.seeAllCategory(checkbox.dataset.handle);
        });
      });

      if (seeAllBtns) {
        seeAllBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.seeAllCategory('pickleball-paddles');
          });
        });
      }
    },
  
    setMaxHeight: function(category) {
      const child = category.querySelector('.product-card');
      if (child) {
        const height = child.offsetHeight;
        if (category.querySelector('.category-products')) {
          category.querySelector('.category-products').style.maxHeight = height - 2 + 'px';
        } else {
          category.style.maxHeight = height - 2 + 'px';
        }
      }
    },
  
    seeAllCategory: function(handle) {
      if (handle == 'pickleball-paddles') {
        const {categoryContainers} = this;
        categoryContainers.forEach((container) => {
          if (!container.classList.contains('all-paddles-container')) {
            container.style.display = 'none';
          } else {
            container.style.display = 'block';
            container.querySelector('.category-products').classList.add('expanded');
            const categoryHeader = container.querySelector('.category-row');
            if (categoryHeader) {
              categoryHeader.style.display = 'none';
            }
          }
        });
      } else {
        const url = '/collections/' + handle; 
        window.location.href = url;
      }
    }
  };